import { useState } from 'react'
import { cn } from '@/lib/utils'

/**
 * Image avatar that falls back to an initial when there is no photo or the
 * photo fails to load (e.g. blocked Google profile URLs).
 */
export function Avatar({
  src,
  name,
  className,
}: {
  src?: string | null
  name?: string | null
  className?: string
}) {
  const [failed, setFailed] = useState(false)

  if (src && !failed) {
    return (
      <img
        src={src}
        alt=""
        loading="lazy"
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
        className={cn('size-9 shrink-0 rounded-full object-cover', className)}
      />
    )
  }
  return (
    <div
      className={cn(
        'flex size-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-semibold text-primary',
        className,
      )}
    >
      {(name || '?').charAt(0).toUpperCase()}
    </div>
  )
}
